<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      Create New - Project Element
      <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
          <mat-panel-title id="lblDocument">
              Project Element
          </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="formGroup">
          <div class="row eip-pt-20">
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <EIPAutoComplete ShowTextValueField='N' TextField="cedDescription"  ValueField="cedId" [defaultValue]='selectedModuleId' WaterMarkText="Module" setId="moduleId" [clearValue]='selectedModuleClear' [dataSource]='moduleList' [IsDisabled]="!this.isCreate" (valueChange)='changeModuleList($event)' [IsCascading]='true'>
                  </EIPAutoComplete>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <EIPAutoComplete ShowTextValueField='N' TextField="dE_Description"  ValueField="dE_Id" [defaultValue]='selectedElementId' setId="elementId" WaterMarkText="Element" [clearValue]='selectedElementClear' [dataSource]='elementsList' [IsDisabled]="!this.isCreate" (valueChange)='changeElementList($event)' [IsCascading]='true'>
                  </EIPAutoComplete>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field style="width: 100%;">
                      <mat-label>Project Element Description</mat-label>
                      <input matInput formControlName="projectElementDescription">
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field style="width: 100%;">
                      <mat-label>Hierarchy</mat-label>
                      <input matInput type="number" formControlName="hierarchy">
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field style="width: 100%;">
                      <mat-label>Sort By</mat-label>
                      <input matInput type="number" formControlName="sortBy">
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Has Dependency</mat-label>
                      <mat-slide-toggle color="primary" formControlName="hasDependency">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Dependent On Element" TextField="dE_Description" (valueChange)='changeDependentElementList($event)'  ValueField="dE_Id" [clearValue]='selectedDependentElementClear' setId="dependentElementId" [dataSource]='dependentElementList' [defaultValue]='selectedDependentElementId' [IsDisabled]="!getFormGroupValue('hasDependency')" [IsCascading]='true'>
                  </EIPAutoComplete>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Mandatory</mat-label>
                      <mat-slide-toggle color="primary" formControlName="isMandatory">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Visible</mat-label>
                      <mat-slide-toggle formControlName="isVisible" color="primary">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Default Select</mat-label>
                      <mat-slide-toggle formControlName="isDefaultSelect" color="primary">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Numbering</mat-label>
                      <mat-slide-toggle formControlName="isNumbering" color="primary">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Serial Number</mat-label>
                      <mat-slide-toggle formControlName="isSerialNumber" color="primary">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Active Status</mat-label>
                      <mat-slide-toggle formControlName="isActive" color="primary">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="isShowListPageIcon">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Show List Page</mat-label>
                      <mat-slide-toggle formControlName="isShowListPage" color="primary">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="showMemberElementIcon">
                  <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>Member Element Detail Access</mat-label>
                      <mat-slide-toggle formControlName="isMemberAccess" color="primary">
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea>
                  </mat-form-field>
              </div>
          </div>
      </form>
  </mat-expansion-panel>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button (click)="saveNewElementLink()" class="btn btn-primary" [disabled]="!formGroup.valid" type="submit"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>
      <button (click)="clearValues()" class="btn btn-secondary"><i class="fa fa-reset" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Reset</button>
  </div>
</div>